import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  rootNoData: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F7F8FC',
    color: '#9A9AAF',
    height: '224px',
    boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.03)',
    fontWeight: 400,
    fontSize: '14px',
    position: 'relative',
    " > div": {
      marginTop: '44px'
    }
  },
  noDataText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    color: '#9A9AAF',
    marginTop: '16px',
    marginBottom: '12px',
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
  },
  integrationIdInput: {
    marginBottom: '16px',
  },
  importChoice: {
    width: 'calc((100% - 25px) / 2)',
    marginLeft: '24px',
    textAlign: 'center',
  },
  newEvaluationChoice: {
    width: 'calc((100% - 25px) / 2)',
    marginRight: '24px',
    textAlign: 'center',
  },
  evaluateBtnIcon: {
    marginRight: '6px',
  },
  progressBar: {},
  thirdpartyName: {
    fontWeight: 400,
    fontFamily: 'Inter',
    fontSize: '18px',
  },
  stepTitle: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '140%',
    marginBottom: '16px',
    display: 'flex',
    marginTop: '16px',
  },
  stepTitleTooltip: {
    display: 'flex',
  },
  stepChoices: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '16px',
    width: "100%"
  },
  btnWrapper: {
    display: 'flex',
    justifyContent: 'right',
    gap: '16px',
    width: '100%',
    paddingTop: '24px',
  },
  finalButtonWrapper: {
    paddingTop: '32px',
    display: 'flex',
    gap: '16px',
  },
  'separator-vertical': {
    margin: '0 48px',
  },
  'separator-horizontal': {
    margin: '16px 0',
  },
  formContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#F7F8FC',
    color: '#9A9AAF',
    height: '100%',
    boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.03)',
    fontWeight: 400,
    fontSize: '14px',
    padding: '16px',
    paddingTop: '42px',
    gap: '34px',
    minHeight: '224px'
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '34px'
  },
  formInputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "end",
    gap: '24px',
    "& .MuiFormHelperText-root": {
      position: 'absolute'
    }
  },
  goBack: {
    position: 'absolute',
    cursor: 'pointer',
    color: theme.palette.grey.grey400,
    fontFamily: 'Roboto',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '130%',
    display: 'flex',
    alignItems: 'center',
    left: '12px',
    top: '8px',
    gap: '4px',
  },
  companyScopeLabel: {
    flex: 7,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    "& .MuiInputBase-root": {
      backgroundColor: 'white'
    }
  },
  companyScopeLabelBtn: {
    marginLeft: '4px !important'
  },
  companyScopeModalContainer: {
    borderRadius: '4px',
    background: theme.palette.grey.grey100,
    padding: '12px',
    color: theme.palette.black.dark
  },
  companyScopeModalExamples: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '32px'
  },
  companyScopeCorrect: { color: theme.palette.primary.primary500 },
  companyScopeIncorrect: { color: theme.palette.error.error500 },
  userCompanyLabel: {
    flex: 5,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    "& label": {
      alignItems: "end"
    }
  },
  userCompanyLabelFacultative: {
    color: theme.palette.grey.grey300,
    fontWeight: 400,
    lineHeight: '140%',
    fontSize: '14px',
    marginLeft: "4px"
  },
  evaluateBtn: {
    flex: 4,
    marginBottom: '4px'
  },
  assetsLimit: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    lineHeight: '130%',
    color: theme.palette.grey.grey400,
  },
  assetsLimitTitle: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    "& img": {
      marginTop: '4px'
    }
  },
  assetsLimitText: {
    fontWeight: 400,
  },
  sharableCompaniesContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F7F8FC',
    color: '#9A9AAF',
    height: '100%',
    boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.03)',
    fontWeight: 400,
    fontSize: '14px',
    padding: '16px',
    gap: '34px',
    minHeight: '224px'
  },
  sharableCompaniesBloc: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 5,
    gap: '12px'
  },
  choiceLabel: {
    color: theme.palette.grey.grey700,
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 600,
    fontStyle: 'normal',
    lineHeight: '120%',
    letterSpacing: '-0.16px'
  },
  sharingChoice: {
    minWidth: '250px',
    "& .MuiInputBase-root": {
      backgroundColor: 'white'
    },
    "& .MuiSelect-select ": {
      paddingRight: '32px !important'
    }
  },
  shouldShare: {
    color: theme.palette.grey.grey500,
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '140%',
  },
  sharableCompanyUserLabel: {
    flex: 5,
    alignItems: 'center'
  },
  // sharableCompaniesBloc: {},
  label: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '130%',
    color: theme.palette.grey.grey500,
    marginBottom: '16px',
  },
  choiceBlocLabel: {
    color: theme.palette.primary.main,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '130%',
    paddingTop: '16px',
    display: 'flex',
    alignItems: 'flex-start',
    '& img': {
      marginTop: '2px',
      marginRight: '10px',
    },
  },
  choiceBlocSubLabel: {
    color: theme.palette.grey.grey500,
    fontFamily: 'Inter',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%',
  },
  inputBloc: {
    paddingBottom: '16px',
    paddingRight: '16px',
    '& .MuiAutocomplete-root': {
      marginTop: '8px',
      '& .MuiInputBase-root': {
        backgroundColor: '#FFF',
      },
    },
    '& .react-tel-input': {
      marginTop: '8px',
    },
    '& .phone-error': {
      backgroundColor: theme.palette.error.main,
    },
  },
  input: {
    width: '100%',
    marginTop: '8px',
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      fontWeight: 400,
      height: '40px',
      backgroundColor: '#FFF',
    },
  },
  inputError: {
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      fontWeight: 400,
      borderRadius: '12px',
      height: '40px',
      border: '1px solid #FFCCCC',
      color: theme.palette.error.error600,

      '& .MuiOutlinedInput-notchedOutline': {
        border: '0px solid #FFCCCC !important',
      },
    },

    '& .Mui-error': {
      color: theme.palette.error.error600,
    },
  },
  progressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '65px',
    minHeight: '235px',
    backgroundColor: '#F7F8FC',
    marginTop: '18px',
    marginBottom: '4px',
    border: '1px solid #F7F8FC',
    borderRadius: '4px',
    position: 'relative'
  },
  progressStopEvaluation: {
    position: "absolute",
    top: '14px',
    right: '14px'
  },
  progressLine: {
    flex: 1,
    height: "2px",
    backgroundColor: theme.palette.grey.grey200,
    marginTop: "-26px",
    marginLeft: "-35px",
    marginRight: "-35px",
    zIndex: 0,
    "&.line-done": {
      backgroundColor: theme.palette.primary.primary600
    }
  },
  progressBullets: {
    display: 'flex',
    width: '80%',
    maxWidth: '600px',
    justifyContent: 'space-between',
    placeItems: "center",
    zIndex: 5,
  },
  bulletRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 5
  },
  bullet: {
    width: '34px',
    height: '34px',
    display: "flex",
    textAlign: 'center',
    alignContent: 'center',
    alignItems: "center",
    justifyContent: "center",
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
    backgroundColor: '#F7F8FC',
    color: theme.palette.grey.grey500,
    borderRadius: '10px',
    border: '4px solid #FFF',
    boxShadow: '0px 2px 14px rgba(57, 73, 171, 0.32)',
    '&.bullet-active': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.primary200,
    },
    '&.bullet-done': {
      color: '#FFF',
      backgroundColor: theme.palette.primary.primary600,
    },
  },
  bulletLabel: {
    marginTop: '8px',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-0.16px',
    color: theme.palette.grey.grey500,
    '&.label-active': {
      color: theme.palette.grey.grey700,
    },
  },
  moreDetailsBtn: {
    border: "1px solid " + theme.palette.grey.grey300,
    borderRadius: "16px",
    display: "flex",
    gap: "5px",
    padding: "2px 10px",
    marginLeft: "auto",
    color: theme.palette.grey.grey500,
    fontSize: "12px",
    fontWeight: 600,
    backgroundColor: "#FFF",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: theme.palette.grey.grey100
    }
  },
  inputLabel: {
    color: theme.palette.grey.grey500,
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "right",
    display: "flex",
    alignItems: "center",
  },
  progressMessage: {
    alignSelf: 'flex-start',
    marginLeft: '16px',
    marginTop: '24px',
  },
  newEvaluationMessage: {
    alignSelf: 'flex-start',
    marginLeft: '16px',
    marginTop: '24px',
  },
  scoresAvailableWrapper: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '235px',
    backgroundColor: '#F7F8FC',
    marginBottom: '4px',
    position: 'relative'
    // gap: "16px",
  },
  globalMaturityWrapper: {
    background:
      'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(199, 236, 0, 0.05) 0%, rgba(255, 255, 255, 0.10) 100%), #FFF',
    borderRadius: '15px',
    flexGrow: 1,
    margin: '16px 14px',
    padding: '14px 18px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  maturityWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: "#FFF",
    textAlign: 'right',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
  },
  globalMaturityTitle: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    alignSelf: 'flex-start',
    marginBottom: '8px',
    color: theme.palette.black.dark,
    width: '100%',
    justifyContent: 'space-between',
    '& img': {
      verticalAlign: 'bottom',
    },
  },
  globalMaturityChart: {
    height: '110px',
    alignSelf: 'center',
  },
  globalMaturityScore: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    textAlign: 'center',
    color: theme.palette.black.dark,
    position: 'relative',
    bottom: '33px',
    left: '6px',
    '& .score': {
      fontSize: '24px',
    },
    '& .max-score': {
      opacity: 0.4,
    },
  },
  globalScoreDivider: {
    height: '1px',
    backgroundColor: theme.palette.grey.grey200,
    width: '90%',
    marginBottom: '12px',
  },
  globalMaturityLabel: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '5px',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    width: 'fit-content',
    padding: '4px 12px',
    '&.advanced': {
      color: theme.palette.primary.main,
      backgroundColor: "#54CC541A",
    },
    '&.intermediate': {
      color: theme.palette.warning.main,
      backgroundColor: "#FF9A001A",
    },
    '&.basic': {
      color: theme.palette.error.error600,
      backgroundColor: '#CC00011A',
    },
    '&.simple': {
      backgroundColor: "transparent",
      fontSize: '12px',
      fontWeight: 600,
      padding: 0
    }
  },
  scoreVariation: {
    borderRadius: '200px',
    background: theme.palette.primary.primary500,
    boxShadow: '0 18px 40px 0 rgba(112, 144, 176, 0.12)',
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center'
  },
  maturityInfosWrapper: {
    borderRadius: '4px',
    padding: '14px',
    backgroundColor: theme.palette.grey.grey100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: '16px'
  },
  maturityInfos: {
    opacity: 1,
    flexShrink: 0,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%',
    color: theme.palette.black.dark,
    "&:not(:last-child)": {
      marginBottom: '12px'
    },
    "& b": {
      fontWeight: 600,
      lineHeight: '130%'
    }
  },
  scaleContainer: {
    position: 'relative'
  },
  scaleRangeWrapper: {
    display: 'flex'
  },
  scaleRange: {
    position: 'absolute',
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '18px',
    color: theme.palette.grey.grey500,
    top: 0,
    "&.range-0": {
      left: '9.3%'
    },
    "&.range-500": {
      left: '36.7%'
    },
    "&.range-750": {
      left: '70.7%'
    },
    "&.range-1000": {
      left: '97%'
    },
  },
  scaleScoreContainer: {
    height: '100%',
    position: 'absolute',
    top: 0,
    width: '91%'
  },
  scaleScoreWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'absolute',
    height: '100%'
  },
  scaleScoreBubble: {
    position: 'absolute',
    borderRadius: '58px',
    backgroundColor: theme.palette.grey.grey800,
    color: 'white',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '130%',
    padding: '1px 5px',
    zIndex: 5
  },
  scaleScoreLine: {
    position: 'absolute',
    height: '93%',
    width: '1px',
    background: '#7E7E8F',
  },
  scaleWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px'
  },
  scaleTitle: {
    color: theme.palette.black.dark,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '18px',
    marginBottom: '8px'
  },
  scaleLabel: {
    color: theme.palette.grey.main,
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '130%',
    minWidth: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: '8px',
    '& img': {
      verticalAlign: 'text-top',
      width: '16px'
    },
  },
  coloredScaleWrapper: {
    height: '27px',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  coloredScaleSection: {
    flexGrow: 1,
    textAlign: 'center',
    color: 'white',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '130%',
    letterSpacing: '-0.18px',
    padding: '2px',
    zIndex: 6,
    '&.basic': {
      borderRadius: '15px 0 0 15px',
      backgroundColor: theme.palette.error.error600,
      boxShadow: '0px 11.28px 24.231px 0px rgba(204, 0, 1, 0.12), 0px 6.031px 12.955px 0px rgba(204, 0, 1, 0.10), 0px 1.796px 3.857px 0px rgba(204, 0, 1, 0.06)'
    },
    '&.intermediate': {
      backgroundColor: theme.palette.warning.main,
      boxShadow: '0px 11.28px 24.231px 0px rgba(255, 154, 0, 0.12), 0px 6.031px 12.955px 0px rgba(255, 154, 0, 0.10), 0px 1.796px 3.857px 0px rgba(255, 154, 0, 0.06);'
    },
    '&.advanced': {
      borderRadius: '0 15px 15px 0',
      backgroundColor: theme.palette.primary.primary600,
      boxShadow: '0px 11.28px 24.231px 0px rgba(45, 159, 64, 0.12), 0px 6.031px 12.955px 0px rgba(45, 159, 64, 0.10), 0px 1.796px 3.857px 0px rgba(45, 159, 64, 0.06)'
    },
  },
  plainScale: {
    position: 'relative',
    background: '#7E7E8F',
    width: '91%',
    height: '1px',
  },
  plainScaleValue: {
    position: 'absolute',
    color: theme.palette.grey.grey400,
    backgroundColor: theme.palette.grey.grey100,
    borderRadius: '58px',
    zIndex: 10,

    top: '-8px',
    padding: '0 5px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
  },
  ipProviderGraphContainer: {
    padding: '18px',
    paddingTop: 0
  },
  ipProviderRadioButtons: {
    color: theme.palette.grey.grey900,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
    margin: '8px 0'
  },
  ipProviderGraphWrapper: {
    height: '400px'
  },
  scoreDetailModalWrapper: {
    padding: '0 16px'
  },
  letterScoreRow: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '24px'
  },
  letterScoreSquare: {
    width: '62px',
    height: '62px',
    color: 'white',
    textAlign: 'center',
    alignContent: 'center',
    borderRadius: '4px',
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-0.22px',
    "&.score-A": {
      backgroundColor: '#2B983E',
      boxShadow: '0px 11.28px 24.231px 0px rgba(45, 159, 64, 0.12), 0px 6.031px 12.955px 0px rgba(45, 159, 64, 0.10), 0px 1.796px 3.857px 0px rgba(45, 159, 64, 0.06)'
    },
    "&.score-B": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 11.28px 24.231px 0px rgba(45, 159, 64, 0.12), 0px 6.031px 12.955px 0px rgba(45, 159, 64, 0.10), 0px 1.796px 3.857px 0px rgba(45, 159, 64, 0.06)'
    },
    "&.score-C": {
      backgroundColor: theme.palette.warning.warning400,
      boxShadow: '0px 11.28px 24.231px 0px rgba(244, 182, 62, 0.12), 0px 6.031px 12.955px 0px rgba(244, 182, 62, 0.10), 0px 1.796px 3.857px 0px rgba(244, 182, 62, 0.06)'
    },
    "&.score-D": {
      backgroundColor: theme.palette.warning.warning600,
      boxShadow: '0px 11.28px 24.231px 0px rgba(204, 123, 0, 0.12), 0px 6.031px 12.955px 0px rgba(204, 123, 0, 0.10), 0px 1.796px 3.857px 0px rgba(204, 123, 0, 0.06)'
    },
    "&.score-E": {
      backgroundColor: theme.palette.error.error400,
      boxShadow: '0px 11.28px 24.231px 0px rgba(255, 63, 64, 0.12), 0px 6.031px 12.955px 0px rgba(255, 63, 64, 0.10), 0px 1.796px 3.857px 0px rgba(255, 63, 64, 0.06)'
    },
    "&.score--": {
      backgroundColor: theme.palette.grey.grey700,
      boxShadow: '0px 11.28px 24.231px 0px rgba(83, 83, 98, 0.12), 0px 6.031px 12.955px 0px rgba(83, 83, 98, 0.10), 0px 1.796px 3.857px 0px rgba(83, 83, 98, 0.06)'
    }
  },
  letterScoreText: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
    flex: 1
  },
  dialogSubTitle: {
    color: theme.palette.grey.grey500,
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%'
  },
  scoreDetailValueRisksWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: '17px',
    marginBottom: '18px'
  },
  scoreDetailValueWrapper: {
    width: '174px',
    height: '129px',
    flexShrink: 0,
    borderRadius: '10px',
    padding: '16px',
    '&.score-A': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(43, 152, 62, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-B': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(84, 204, 84, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-C': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(255, 174, 51, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-D': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(204, 123, 0, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score-E': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(255, 63, 64, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
    '&.score--': {
      background: 'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(83, 83, 98, 0.10) 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF',
    },
  },
  scoreDetailValueTitle: {
    color: theme.palette.black.dark,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    marginBottom: '12px'
  },
  scoreDetailValueSquare: {
    position: 'relative',
    fontSize: '36px',
    fontWeight: 700,
    lineHeight: '42px',
    fontStyle: 'normal',
    justifyContent: 'center',
    textAlign: 'center',
    '&.score-A': {
      color: '#2B983E',
    },
    '&.score-B': {
      color: theme.palette.primary.main,
    },
    '&.score-C': {
      color: theme.palette.warning.warning400,
    },
    '&.score-D': {
      color: theme.palette.warning.warning600,
    },
    '&.score-E': {
      color: theme.palette.error.error400,
    },
    '&.score--': {
      color: theme.palette.grey.grey700,
    },
  },
  scoreDetailValue: {
    position: 'absolute',
    top: '16%',
    left: '40%'
  },
  scoreDetailRiskWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  scoreDetailRiskTitle: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
    color: theme.palette.black.dark
  },
  scoreDetailRisk: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
  },
  scoreDetailRiskExample: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
    color: theme.palette.grey.grey500
  },
  scoreDetailTestWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '18px',
    background: theme.palette.grey.grey100,
    borderRadius: '4px'
  },
  scoreDetailTestTitle: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
    color: theme.palette.black.dark
  },
  scoreDetailTest: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%',
  },
  scoresDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 3,
    margin: '16px 14px 16px 0',
    gap: '16px',
  },
  scoresButtonsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
    '& button span :first-of-type': {
      marginRight: '4px',
    },
  },
  datesWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '14px',
    flexGrow: 2,
  },
  badgeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '9px',
  },
  badgeDetail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '6px 12px',
    gap: '5px',
    flexShrink: 0,
    borderRadius: '10px',
    backgroundColor: '#F1EFEC',
    color: '#494A49',
    fontFamily: 'Inter',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
  },
  badgeDetailLabel: {
    fontSize: '12px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '& img': {
      verticalAlign: 'bottom',
    },
  },
  scoresWrapper: {
    boxShadow:
      '0px 12.522px 38.692px 0px rgba(210, 208, 225, 0.12), 0px 6.65px 20.549px 0px rgba(210, 208, 225, 0.10), 0px 2.767px 8.551px 0px rgba(210, 208, 225, 0.07)',
    padding: '8px 14px',
    backgroundColor: '#F2F8FC',
    borderRadius: '12px',
    display: "flex",
    width: '100%'
  },
  scoresDetailWrapper: {
    flex: 1
  },
  scoreDetailTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    alignSelf: 'flex-start',
    color: theme.palette.black.dark,
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: '12px',
  },
  scoresDetailTitle: {
    color: theme.palette.grey.grey400,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px',
  },
  scoresDetailLinesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  scoreDetail: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 6px',
    gap: '8px',
  },
  scoreInfoIcon: {
    border: "1px solid " + theme.palette.grey.grey300,
    borderRadius: "16px",
    display: "flex",
    gap: "5px",
    padding: "2px",
    color: theme.palette.grey.grey500,
    fontSize: "12px",
    fontWeight: 600,
    backgroundColor: "#FFF",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: theme.palette.grey.grey100
    }
  },
  scoreLabel: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
    textAlign: 'center',
    marginRight: 'auto',
    color: theme.palette.black.dark,
  },
  scoreValue: {
    fontFamily: 'Inter',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.025px',
    color: '#FFF',
    textAlign: 'center',
    borderRadius: '16px',
    padding: '2px 6px 0 6px',
    minWidth: '52px',
    '& span': {
      fontSize: '14px',
      fontWeight: 700,
      letterSpacing: '0.035px',
    },
    '&.score-A': {
      backgroundColor: '#2B983E',
    },
    '&.score-B': {
      backgroundColor: theme.palette.primary.main,
    },
    '&.score-C': {
      backgroundColor: theme.palette.warning.warning400,
    },
    '&.score-D': {
      backgroundColor: theme.palette.warning.warning600,
    },
    '&.score-E': {
      backgroundColor: theme.palette.error.error400,
    },
    '&.score--': {
      backgroundColor: theme.palette.grey.grey700,
    },
  },
  historyMenuItem: {
    color: theme.palette.grey.grey500,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%',
    "&.Mui-selected": {
      color: theme.palette.primary.primary800,
      fontWeight: 500
    }
  },
  historyListSubHeader: {
    color: theme.palette.grey.grey400,
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '120%'
  },
  graphEvolutionDialog: {
    backgroundColor: theme.palette.grey.grey100,
    padding: '20px 40px',
  },
  graphEvolutionContent: {
    backgroundColor: theme.palette.grey.grey100,
    minWidth: '685px',
    minHeight: '348px',
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0',
  },
  historyBtnTooltipTitle: {
    display: 'flex',
  },
  scopeChangeButton: {
    position: 'absolute',
    right: '8px',
    bottom: '8px',
  },
  scopeChangeDetailWrapper: {
    color: theme.palette.black.dark,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
  },
  scopeChangesBloc: {
    borderRadius: '0px 0px 8px 8px',
    background: 'rgba(242, 243, 247, 0.50)',
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '8px',
  },
  scopeChangeItem: {
    color: theme.palette.black.dark,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  scopeChangeValue: {
    color: theme.palette.grey.grey600,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '120%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '4px',
    '& img': {
      width: '16px',
    },
  },
  blurred: {
    filter: 'blur(10px)',
  },
  errorWrapper: {
    zIndex: 100,
    width: '100%',
    height: '100%',
    minHeight: '235px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    placeContent: 'center',
    background: '#FCF9FB',
    backdropFilter: 'blur(75px)',
    borderRadius: '6px',
  },
  errorTitle: {
    fontWeight: 600,
  },
}));

export default useStyles;

